import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  gradientOverlay: {
    width: '100%',
    height: ({ height }) => height,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background:
      'linear-gradient(180deg, rgba(86,86,86,0.57) 0%, rgba(216,216,216,0) 100%)'
  }
});

const GradientOverlay = ({ classes }) => {
  return <div className={classes.gradientOverlay}></div>;
};

GradientOverlay.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(GradientOverlay);
